import { atom, selector } from 'recoil';
import { v4 } from 'uuid';
import { getConfigVariable } from '../../fn/Config';
import AxiosService from '../../services/AxiosService';
import { sessionId } from './SessionId';
import './AppointmentSelectionVersion';
import './OrderingMode';

const API_CLIENT_ID = getConfigVariable('API_CLIENT_ID');
const VERSION = getConfigVariable('VERSION');

const funnelId = window.eventFunnel ? window.eventFunnel : 'default';
const apiVersion = window.apiversion ? window.apiversion : '1';
const dateSelection = window.dateselectionversion
  ? window.dateselectionversion
  : '1';
// V1 was removed, so this is always '2'. The key is retained for one release
// because dropping it changes the shape of every logged action, and
// e2e/helpers/event-capture.js still reads featureFlag.personalInfoVersion.
const personalInfoVersion = '2';
const appointmentSelectionVersion = window.appointmentSelectionVersion || '2';
const orderingMode = window.orderingMode || 'legacy';

export const ActionState = atom({
  key: 'ActionState',
  default: {
    previousActionId: null,
    uri: `/log`,
    clientId: `${API_CLIENT_ID}`,
  },
});

export const LogAction = selector({
  key: 'LogAction',
  set: ({ set, get }, { context, subject, object, verb }) => {
    // get the current state
    const { uri, clientId, previousActionId } = get(ActionState);
    const actionId = v4();
    const timestamp = Date.now();

    AxiosService.post(`${uri}`, {
      uri,
      clientId,
      timestamp,
      sessionId,
      actionId,
      previousActionId,
      context,
      subject,
      object,
      verb,
      version: `${VERSION}-${funnelId}-${apiVersion}`,
      featureFlag: {
        apiVersion,
        dateSelection,
        personalInfoVersion,
        appointmentSelectionVersion,
        orderingMode,
      },
    })
      // .then(r => console.log("LogAction: result", r))
      .catch((e) => console.error('LogAction: error', e));

    set(ActionState, {
      uri,
      clientId,
      previousActionId: actionId,
    });
    return true;
  },
});
